// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K2oV","label":"styles_label__23lYi"};